// extracted by mini-css-extract-plugin
module.exports = {"error":"choose_error__2FVqZ"};